<template lang="pug" src="./sqlReportsCategories.pug"></template>
<style lang="scss" src="./sqlReportsCategories.scss" scoped></style>

<script>
import { mapState } from 'vuex'
import { requiredIf } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import validate from '@/mixins/validate'

export default {
    mixins: [validate, validationMixin],
    data: () => ({
        saveModal: false,
        removeModal: false,
        chosenCategory: {
            name: null
        }
    }),
    validations: {
        chosenCategory: {
            name: {
                required: requiredIf(function() {
                    return this.saveModal
                })
            }
        }
    },
    computed: {
        ...mapState({
            categories: state => state.sqlReports.roleCategories
        }),
        headers() {
            return ['name', 'action'].map(it => ({
                text: this.$vuetify.t(`$vuetify.pages.ExtendedReports.Categories.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }))
        },
        isEditingMode() {
            return !!this.chosenCategory.id
        },
        saveAction() {
            return this.isEditingMode ? 'updateReportCategory' : 'createReportCategory'
        },
        saveModalTitle() {
            return this.isEditingMode ? 'edit' : 'create'
        }
    },
    created() {
        this.$store.dispatch('sqlReports/getReportsCategories', false)
    },
    methods: {
        openModal(category, modal) {
            this.$data[modal] = true

            if (!category) return

            this.chosenCategory = Object.assign({}, {
                ...category
            })
        },
        async saveCategory() {
            if (this.$v.chosenCategory.$invalid) {
                this.$v.chosenCategory.$touch()
                return
            }

            await this.$store.dispatch(`sqlReports/${this.saveAction}`, this.chosenCategory)
                .finally(() => {
                    this.$nextTick(() => {
                        this.closeModal('saveModal')
                        this.$v.chosenCategory.$reset()
                    })
                })
        },
        async removeCategory() {
            await this.$store.dispatch('sqlReports/removeReportCategory', this.chosenCategory.id)
                .finally(() => {
                    this.$nextTick(() => {
                        this.closeModal('removeModal')
                    })
                })
        },
        closeModal(modal) {
            this.$data[modal] = false
            this.chosenCategory = {
                name: null
            }
        }
    }
}
</script>
